import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const Text_Shadow = () => {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">✨ CSS Text Shadow</h1>

      {/* Intro */}
      <p className="tutorial-intro">
        The <code>text-shadow</code> property adds shadow effects to text. You
        can apply single or multiple shadows to create creative and stylish text
        designs.
      </p>

      {/* Syntax */}
      <div className="tutorial-section">
        <h2 className="section-title">Basic Syntax</h2>
        <CodeCopyBlock
          code={`selector {
  text-shadow: horizontal-offset vertical-offset blur-radius color;
}`}
        />
        <p>
          - <strong>Horizontal-offset</strong>: Moves the shadow left/right.{" "}
          <br />- <strong>Vertical-offset</strong>: Moves the shadow up/down.{" "}
          <br />- <strong>Blur-radius</strong> (optional): Defines how blurred
          the shadow is. <br />- <strong>Color</strong>: Shadow color.
        </p>
      </div>

      {/* Example 1 */}
      <div className="tutorial-section">
        <h2 className="section-title">Simple Shadow</h2>
        <CodeCopyBlock
          code={`h1 {
  text-shadow: 2px 2px 5px gray;
}`}
        />
        <h2 style={{ textShadow: "2px 2px 5px gray" }}>
          This is a simple shadow
        </h2>
      </div>

      {/* Example 2 */}
      <div className="tutorial-section">
        <h2 className="section-title">Glow Effect</h2>
        <CodeCopyBlock
          code={`h1 {
  text-shadow: 0 0 10px #00ffcc;
}`}
        />
        <h2 style={{ textShadow: "0 0 10px #00ffcc", color: "#00ffee" }}>
          Glowing Text
        </h2>
      </div>

      {/* Example 3 */}
      <div className="tutorial-section">
        <h2 className="section-title">Multiple Shadows</h2>
        <CodeCopyBlock
          code={`h1 {
  text-shadow: 2px 2px 2px red, -2px -2px 2px blue;
}`}
        />
        <h2
          style={{
            textShadow: "2px 2px 2px red, -2px -2px 2px blue",
            color: "#333",
          }}
        >
          Multiple Shadows
        </h2>
      </div>

      {/* Example 4 */}
      <div className="tutorial-section">
        <h2 className="section-title">3D Shadow Effect</h2>
        <CodeCopyBlock
          code={`h1 {
  text-shadow: 3px 3px 0 #ff0000,
               6px 6px 0 #00ff00,
               9px 9px 0 #0000ff;
}`}
        />
        <h2
          style={{
            textShadow:
              "3px 3px 0 #ff0000, 6px 6px 0 #00ff00, 9px 9px 0 #0000ff",
          }}
        >
          3D Shadow Effect
        </h2>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">Next Steps</h2>
        <p>
          After text shadows, the next important step is working with{" "}
          <a href="/css/fonts" className="learn-more">
            CSS Fonts
          </a>{" "}
          to customize how your text looks with different typefaces.
        </p>
      </div>
    </div>
  );
};

export default Text_Shadow;
